import { render } from "./LinkListBlock.vue?vue&type=template&id=c0143504"
import script from "./LinkListBlock.vue?vue&type=script&lang=js"
export * from "./LinkListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__